module.exports = __webpack_public_path__ + "static/media/78.6a36bff9.gif";